import actionTypes from './actions/actionTypes'

const {
  REQUEST_UPDATEIPADDRESS,
  RECEIVE_UPDATEIPADDRESS,
  ERROR_UPDATEIPADDRESS
} = actionTypes

const manageIpAddressReducer = (state = {
  isUpdating: false,
  error: false
}, action) => {
  switch (action.type) {
    case REQUEST_UPDATEIPADDRESS:
      return Object.assign({}, state, {
        isUpdating: true,
        error: false
      })
    case RECEIVE_UPDATEIPADDRESS:
      return Object.assign({}, state, {
        isUpdating: false,
        error: false
      })
    case ERROR_UPDATEIPADDRESS:
      return Object.assign({}, state, {
        isUpdating: false,
        error: true
      })
    default:
      return state
  }
}

export default manageIpAddressReducer



// WEBPACK FOOTER //
// src/routes/ManageIpAddress/reducer.js